import { render } from "./characterModal.vue?vue&type=template&id=5937e9f6&scoped=true"
import script from "./characterModal.vue?vue&type=script&lang=js"
export * from "./characterModal.vue?vue&type=script&lang=js"

import "./characterModal.vue?vue&type=style&index=0&id=5937e9f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5937e9f6"

export default script